module.exports = __webpack_public_path__ + "media/0013.0190155d.mp3";